import {
  IonContent,
  IonPage,
  useIonViewWillEnter,
  useIonViewDidLeave,
} from '@ionic/react'
import React, { useState } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { observer } from 'mobx-react'
import { pointCardMobx, memberMobx, mktConfigMobx } from '@mobxStore'
import {
  MktLoading,
  ResultAlert,
  CouponItem,
  MktEmpty,
  MarketDetailTab,
  CouponDetail
} from '@cps'
import { ddayjs } from '@dt/fe-utils'
import mktController from 'controllers/mktController'
import ActivityApi from '@api/activity.api'
import MemberCardApi from '@api/memberCard.api'
import MemberApi from '@api/member.api'
import { modalLayer, useHistoryNew, toast } from '@utils'
import { useMktConfigInit } from '@common/hooks'
import { keyBy, each } from '@dt/fe-utils/dist/lodash'
import { MktHeader } from 'pages/mkt/components'
import { storeMobx } from 'restaurant'
import PointSquare from '../components/pointSquare'
import PointNumber from '../components/pointNumber'
import PointDetail from '../components/pointDetail'
import PointTemp from '../components/pointTemp'
import './index.scss'
import codeSendBgImg from '@img/mkt/codeSendBg.jpeg'

/** 获取集点卡状态， 0未完成 1完成 2超过上限 */
const getStatus = (data: any) => {
  if (data.extra?.participateNum && parseInt(data.partTakeNum) >= parseInt(data.extra?.participateNum)) {
    return 2
  } else if (data.points >= data.collectPointTarget) {
    return 1
  } else {
    return 0
  }
}

interface IProps extends IPage, RouteComponentProps { }

const PointCardDetail: React.FC<IProps> = (props) => {
  const { match } = props
  const { id } = match.params as any
  const { storeIdToStore } = storeMobx
  const history = useHistoryNew()
  const [showLoading, setShowLoading] = useState<boolean>(true)
  const [couponDetails, setCouponDetails] = useState<any>({})
  const [data, setData] = useState<any>({})
  const [status, setStatus] = useState<number>(1)
  const [cards, setCards] = useState([])
  const [isEnd, setIsEnd] = useState<boolean>(false)

  const getData: any = () => {
    pointCardMobx.getPointCardDetail(id).then((res) => {
      setData(res)
      setShowLoading(false)
      if (res) {
        setStatus(getStatus(res))
        if (Date.now() > ddayjs(res.endTime).valueOf() || res.status === 'disable') {
          setIsEnd(true)
        } else {
          setIsEnd(false)
        }
      }
      if (res && res.cards && res.cards.length > 0 && cards.length === 0) {
        MemberCardApi.getAllLevelCardList({
          cardIds: res.cards,
        }).then((res) => setCards(res))
      }
      if (res && res.coupons.length > 0 && Object.keys(couponDetails).length === 0) {
        ActivityApi.getCouponsList({
          couponIds: res.coupons.map((item) => item.couponId),
        }).then((coup) => {
          setCouponDetails(keyBy(coup, 'couponId'))
        })
      }
    })
  }

  const showDetail = () => {
    modalLayer(PointDetail, { data: data, cards: cards, couponDetails })
  }
  const acquireSuccess = () => {
    modalLayer(ResultAlert, {
      title: i18n.t('mkt.coupon.receivedSucc'),
      des: i18n.t('mkt.activity.couponTip'),
      btnTitle: i18n.t('mkt.common.toUse'),
      children:
        data.coupons.map((item: any, index: number) => {
          const hasItem: any = couponDetails[item.couponId]
          return hasItem && (
            <div className='coupon-block' key={`${index}-${item.couponId}`}>
              <CouponItem
                type={status === 0 ? 'get' : 'use'}
                couponInfo={hasItem}
                cnt={item.couponCnt > 1 ? item.couponCnt : ''}
              >
              </CouponItem>
            </div>
          )
        }),
    }).then(() => {
      history.replace('/menu')
    }, () => { })
  }

  const exchangeCoupons = () => {
    memberMobx.acquireActiveCoupons(Number(id)).then(() => {
      acquireSuccess()
      setTimeout(() => {
        getData()
      }, 800)
    }).catch((res) => {
      if (res.code === 4027) {
        toast({ message: i18n.t('mkt.pointCard.insufficient') })
      }
      if (res.code === 4026) {
        toast({ message: i18n.t('mkt.pointCard.maxCount', { n: data.extra?.participateNum }) })
      }
    })
  }

  const renderProductName = (product) => {
    let str = product.productName || product.categoryName || ''
    if (product.scaleName) {
      return `${str}(${product.scaleName})`
    }
    return `${str}${product.categoryNo && !product.productNo && !product.scaleNo
      ? `(${i18n.t('mkt.pointCard.allCatgory')})`
      : ''
    }`
  }

  const getStoreName = (stores: any[]) => {
    const names: any = []
    each(stores, (item: number) => {
      if (storeIdToStore[item]) names.push(storeIdToStore[item].storeName)
    })
    return names
  }

  useIonViewWillEnter(() => {
    setShowLoading(true)
    if (id) {
      if (memberMobx.isLogin) {
        getData()
      } else {
        setTimeout(() => {
          history.push('/login')
        }, 0)
      }
    }
  }, [id])

  useIonViewDidLeave(() => {
    setShowLoading(false)
  }, [])

  useMktConfigInit()

  return (
    <IonPage className='point-card-detail-page'>
      <MktHeader
        className='point-card-header'
        title={data ? data.activityName : ''}
        onBack={() => mktController.goBack(history)}
      >
      </MktHeader>
      <IonContent className='page-content'>
        {showLoading
          ? <MktLoading></MktLoading>
          : (
            <>
              {
                (!data?.extra?.displayStyle || data?.extra?.displayStyle?.tempType === 'default')
                  ? (
                    <div className='point-card-body'>
                      <div className='point-card-bg'>
                        <img src={data?.playbill || codeSendBgImg} alt='' />
                      </div>
                      <MarketDetailTab
                        info={status === 0 ? i18n.t('mkt.pointCard.stillHas', {
                          n: `<span style='color: #ff0'>${data.collectPointTarget - data.points}</span>`,
                        }) : ''} onClick={() => {
                          showDetail()
                        }}
                      >
                      </MarketDetailTab>
                      <div className='point-card-detail'>
                        {data && data.activityId && !isEnd ? (
                          <div className='point-detail-main '>
                            {data.collectPointTarget > 9 ? (
                              <PointNumber data={data}></PointNumber>
                            ) : (
                              <PointSquare data={data}></PointSquare>
                            )}
                            <div className='main-bottom'>
                              {
                                data.points >= data.collectPointTarget && <div className='collect-succ'>{i18n.t('mkt.pointCard.success')}</div>
                              }
                              {status === 0 &&
                                <div
                                  data-cypid='mmgToMenu'
                                  className='main-btn'
                                  onClick={() => history.replace('/menu')}
                                >
                                  {i18n.t('mkt.pointCard.gotoPoint')}
                                </div>}
                              {
                                status === 1 &&
                                  <div data-cypid='mmgExchangePointCard' className='main-btn' onClick={exchangeCoupons}>
                                    {i18n.t('mkt.pointCard.getRewards')}
                                  </div>
                              }
                              {
                                status === 2 &&
                                  <div className='has-limit'>
                                    {i18n.t('mkt.market.hasReachedTheLimit')}
                                  </div>
                              }
                              <div className='activity-time'>{ddayjs(data.startTime).format('YYYY-MM-DD')} {i18n.t('mkt.common.to')} {ddayjs(data.endTime).format('YYYY-MM-DD')}</div>
                            </div>
                          </div>
                        ) : (
                          <MktEmpty type='end' text={i18n.t('mkt.market.eventIsOver')}></MktEmpty>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className='point-temp-body'>
                      <div className='point-temp-content'>
                        <PointTemp
                          data={{
                            playbill: data.playbill || codeSendBgImg,
                            participateNum: data.collectPointTarget,
                            iconEnable: data.extra.iconEnable,
                            iconDisable: data.extra.iconDisable,
                            displayStyle: data.extra.displayStyle,
                            points: data.points
                          }}
                        >
                        </PointTemp>
                      </div>
                      <div className='main-bottom'>
                        {
                          data.points >= data.collectPointTarget && <div className='collect-succ'>{i18n.t('mkt.pointCard.success')}</div>
                        }
                        {status === 0 &&
                          <div
                            data-cypid='mmgToMenu'
                            className='main-btn'
                            onClick={() => history.replace('/menu')}
                          >
                            {i18n.t('mkt.pointCard.gotoPoint')}
                          </div>}
                        {
                          status === 1 &&
                            <div data-cypid='mmgExchangePointCard' className='main-btn' onClick={exchangeCoupons}>
                              {i18n.t('mkt.pointCard.getRewards')}
                            </div>
                        }
                        {
                          status === 2 &&
                            <div className='has-limit'>
                              {i18n.t('mkt.market.hasReachedTheLimit')}
                            </div>
                        }
                      </div>
                      <div className='detail-des'>
                        <div className='title'>{i18n.t('mkt.pointCard.activeRewards')}</div>
                        {
                          data.coupons.map((item: any, index: number) => {
                            const hasItem: any = couponDetails[item.couponId]
                            return hasItem && (
                              <div className='coupon-block' key={`${index}-${item.couponId}`}>
                                <CouponItem
                                  type='get'
                                  couponInfo={hasItem}
                                  cnt={item.couponCnt > 1 ? item.couponCnt : ''}
                                  onDetail={() => {
                                    modalLayer(CouponDetail, { type: 'get', couponInfo: hasItem }, 'couponDetail')
                                  }}
                                >
                                </CouponItem>
                              </div>
                            )
                          })
                        }
                      </div>
                      {data.extra.copywriting && (
                        <div className='detail-des'>
                          <div className='title'>{i18n.t('mkt.activity.introduce')}</div>
                          <div className='info'>{data.extra.copywriting}</div>
                        </div>
                      )}
                      <div className='detail-des'>
                        <div className='title'>{i18n.t('mkt.activity.times')}</div>
                        <div className='info'>{ddayjs(data.startTime).format('YYYY-MM-DD')} {i18n.t('mkt.common.to')} {ddayjs(data.endTime).format('YYYY-MM-DD')}</div>
                      </div>
                      <div className='detail-des'>
                        <div className='title'>{i18n.t('mkt.pointCard.rule')}</div>
                        <div className='info'>
                          {data.orderFee
                            ? i18n.t('mkt.pointCard.getRuleByPrice', {
                              n: data.orderFee,
                            })
                            : i18n.t('mkt.pointCard.getRuleByProduct')}
                        </div>
                        <div className='info'>
                          <span>{i18n.t('mkt.pointCard.limit')}: </span>
                          <span>{i18n.t(
                            data.collectPointIfOverly
                              ? 'mkt.pointCard.noLimit'
                              : 'mkt.pointCard.max1'
                          )}
                          </span>
                        </div>
                        <div className='info'>
                          <span>{i18n.t('mkt.pointCard.countLimit')}: </span>
                          <span>
                            {data.extra?.participateNum
                              ? i18n.t('mkt.pointCard.maxCount', {
                                n: data.extra?.participateNum,
                              })
                              : i18n.t('mkt.pointCard.noLimit')}
                          </span>
                        </div>
                        <div className='info'>
                          <span>{i18n.t('mkt.pointCard.channel')}: </span>
                          <span>
                            {data.channelEatType && !data.channelEatType.isAll
                              ? data.channelEatType.channels.map((item: any) => {
                                if (item.enable) {
                                  const eatTypes = item?.eatTypes?.length ? item.eatTypes.map((i: string) => i18n.t(`menu.${i}`)) : []
                                  return `${mktConfigMobx.eatTypeAndChannelMap[item.key]?.value || item.key}${eatTypes.length ? `(${eatTypes.join(',')})` : ''}`
                                } else {
                                  return ''
                                }
                              }).filter((item: any) => !!item).join(',')
                              : i18n.t('mkt.market.allChannels')}
                          </span>
                        </div>
                        <div className='info'>
                          <span>{i18n.t('mkt.pointCard.member')}: </span>
                          <span>
                            {data.isAllMember && i18n.t('mkt.pointCard.allMember')}
                            {!data.isAllMember &&
                              cards.map((item, index) => { return item.cardName ? `${item.cardName}${index + 1 === cards.length ? '' : ', '}` : '' })}
                          </span>
                        </div>
                        {data.orderFee ? '' : (
                          <>
                            {data.productRelation === 'all' || data.products?.length ? (
                              <div className='info'>
                                <span>{i18n.t(`mkt.pointCard.${data.productRelation === 'excluded' ? 'excludeProduct' : 'product'}`)}: </span>
                                <span>
                                  {data.productRelation === 'all' ? (
                                    i18n.t('mkt.coupon.allMealApplicable')
                                  ) : data.products.map(renderProductName).join(', ')}
                                </span>
                              </div>
                            ) : ''}
                            {data.productComboRelation === 'all' || data.comboProducts?.length ? (
                              <div className='info'>
                                <span>{i18n.t(`mkt.pointCard.${data.productComboRelation === 'excluded' ? 'excludeCombo' : 'combo'}`)}: </span>
                                <span>
                                  {data.productComboRelation === 'all' ? (
                                    i18n.t('mkt.coupon.allComboApplicable')
                                  ) : data.comboProducts.map(renderProductName).join(', ')}
                                </span>
                              </div>
                            ) : ''}
                          </>
                        )}
                        <div className='info'>
                          <span>{i18n.t('mkt.pointCard.store')}: </span>
                          <span>
                            {data.isAllStore && i18n.t('mkt.pointCard.allStore')}
                            {!data.isAllStore && getStoreName(data.stores).join(', ')}
                          </span>
                        </div>
                        {
                          !!data.products?.length &&
                            <div className='info'>
                              <span>{i18n.t('mkt.pointCard.preferentialFood')}: </span>
                              <span>
                                {
                                  data?.extra?.discountPartake
                                    ? <span>{i18n.t('mkt.pointCard.notParticipating')}</span>
                                    : (
                                      <>
                                        {
                                          data?.extra?.discountPartakeType && data?.extra?.discountPartakeType?.length === 1
                                            ? (
                                              <span>
                                                {
                                                  data?.extra?.discountPartakeType?.includes('memberCard')
                                                    ? i18n.t('mkt.pointCard.participatingMember')
                                                    : i18n.t('mkt.pointCard.participatingOther')
                                                }
                                              </span>
                                            ) : <span>{i18n.t('mkt.pointCard.participating')}</span>
                                        }
                                      </>
                                    )
                                }
                              </span>
                            </div>
                        }
                      </div>
                    </div>
                  )
              }
            </>
          )}
      </IonContent>
    </IonPage>
  )
}
export default observer(PointCardDetail)
